import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AcreImage = _resolveComponent("AcreImage")!
  const _directive_outside_click = _resolveDirective("outside-click")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip",
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onHoverEnter && _ctx.onHoverEnter(...args))),
    onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onHoverEnter && _ctx.onHoverEnter(...args))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onHoverLeave && _ctx.onHoverLeave(...args))),
    onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onHoverLeave && _ctx.onHoverLeave(...args))),
    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["stop"]))
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      ref: "activatorRef",
      class: _normalizeClass(["tooltip-activator", { 'is--border': _ctx.activatorBordered, 'is--help': _ctx.helpCursor, 'is--disabled': _ctx.disabled }])
    }, [
      _renderSlot(_ctx.$slots, "activator")
    ], 2)), [
      [_directive_outside_click, { handler: _ctx.onMouseLeave }]
    ]),
    _createElementVNode("div", {
      ref: "contentRef",
      class: _normalizeClass(["tooltip-content", [_ctx.side, { active: _ctx.isActive, show: _ctx.isShow }]]),
      style: _normalizeStyle(_ctx.contentStyles)
    }, [
      (_ctx.contentIcon === 'circle')
        ? (_openBlock(), _createBlock(_component_AcreImage, {
            key: 0,
            class: "info-circle-icon",
            src: require(`!raw-loader!./assets/gray-info-circle.svg`),
            alt: "info"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 6)
  ], 32))
}